
import { defineComponent, onMounted, reactive, toRefs, ref, unref, inject } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import AOS from 'aos';
import VPagination from '@hennge/vue3-pagination';
import { hideModal } from '@/core/helpers/dom';
import '@hennge/vue3-pagination/dist/vue3-pagination.css';
import StorageService from '@/core/services/StorageService';
import * as _ from 'lodash';
import QrcodeVue from 'qrcode.vue';

export default defineComponent({
  name: 'all_programs',
  components: {
    VPagination,
    QrcodeVue,
  },
  setup() {
    const helpers: any = inject('helpers');
    const store = useStore();
    const router = useRouter();
    const i18n = useI18n();
    const { t } = useI18n();

    const ModalShow = ref<HTMLElement | null>(null);

    onMounted(() => {
      AOS.init();
      getAllProgramsResult();
      getProfile();
    });

    const state = reactive({
      loading: false,
      currentItem: null,
      acceptTerms: false,
      page: 1,
      totalPages: 1,
      pageLimit: 10,
      items: [],
      securityGateQrCodeDataStr: '',
      QRCode: true,
    });

    const updateHandler = (e) => {
      state.page = e;
      getAllProgramsResult();
    };
    const getAllProgramsResult = () => {
      state.loading = true;
      state.items = [];
      let payload = {
        paginated: true,
        limit: state.pageLimit,
        page: state.page,
      };
      setTimeout(() => {
        store.dispatch('modulePrograms/listUserProgramResults', payload)
          .then(({ data }) => {
            state.loading = false;
            let response = data.data;
            state.items = response.docs;
            state.totalPages = response.totalPages;
          })
          .catch((response) => {
            state.loading = false;
            helpers.handleResponse(response, t, router, store, {});
          });
      }, 100);
    };

    const showModalPrograms = (item: any) => {
      state.acceptTerms = false;

      // Ensure lastFiltrationTestStagesWithPublishExamDetailsTrue is an array
      const stages = item.lastFiltrationTestStagesWithPublishExamDetailsTrue;
      if (Array.isArray(stages) && stages.length > 0) {
        // Get the last object in the array
        const lastObject = stages[stages.length - 1];

        // Safely check if the QRCode field exists and assign its value
        state.QRCode = lastObject && 'QRCode' in lastObject ? lastObject.QRCode : true;
      }
      state.currentItem = item;
    };

    const goToApplyPrograms = (item) => {
      hideModal(ModalShow.value);
      // let dynamicFormsJsonWithOrder: any = item.dynamicFormsJsonWithOrder[0];
      router.push({ name: 'apply_program_page', params: { id: item._id } });
    };

    const goToPrograms = () => {
      router.push({ name: 'all_programs_page' });
    };
    const goToMyPrograms = () => {
      router.push({ name: 'my_programs_page' });
    };

    const getProfile = () => {

      store.dispatch('moduleAuth/verify')
        .then(({ data }) => {
          state.loading = false;
          let response = data.data;
          state.securityGateQrCodeDataStr = JSON.stringify(response.securityGateQrCodeData);
        })
        .catch((response) => {
          state.loading = false;
          helpers.handleResponse(response, t, router, store, {});
        });
    };
    return {
      ...toRefs(state),
      router,
      ModalShow,
      i18n,
      store,
      updateHandler,
      showModalPrograms,
      goToApplyPrograms,
      goToPrograms,
      goToMyPrograms,
    };
  },
});
